// import { Action, action, computed, createStore } from 'easy-peasy';
import { enableMapSet } from 'immer';

// ... existing code ...

// 在创建 store 之前启用 MapSet 支持
enableMapSet();

// interface StoreModel {
//     mapState: {
//         data: Map<string, string>;
//     };
//     setMapData: Action<StoreModel, { key: string; value: string }>;
// }

// const store = createStore<StoreModel>({
//     mapState: {
//         data: new Map([['key', 'value']]),
//     },

//     setMapData: action((state, payload) => {
//         // 创建新的 Map 实例
//         const newMap = new Map(state.mapState.data);
//         newMap.set(payload.key, payload.value);
//         state.mapState.data = newMap;
//     }),
// });

// store.dispatch.setMapData({ key: 'newKey', value: 'newValue' }); // 更新数据
// console.log(store.getState().mapState.data); // 访问 Map 数据
